export default "__VITE_ASSET__71f5eebc__"